import modal from './Modal';

export default function deleteAccountModal(action:string) {
  return {
    password: '',
    message: '',
    loading: false,
    getSessionInfo() {
      return fetch('/actions/users/session-info', {
        headers: {
          Accept: 'application/json',
        },
      })
        .then((response) => response.json());
    },
    submitData() {
      this.message = '';
      this.loading = true;

      this.getSessionInfo()
        .then((session) => {
          const params = new FormData();
          params.append('userId', session.id);
          params.append('password', this.password);

          fetch(action, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-CSRF-Token': session.csrfTokenValue,
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: params,
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              return response.json();
            })
            .then((data) => {
              if (data.success) {
                window.location.href = data.redirectUrl;
              } else {
                throw new Error(data.errors.join(' '));
              }
            })
            .catch((e) => {
              this.message = e.message;
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch((e) => {
          this.message = e.message;
          this.loading = false;
        });
    },
    ...modal(),
  };
}
